module.exports = __webpack_public_path__ + "img/2ba1d60.png";